import classNames from 'classnames/bind';
import React, { useState, useMemo } from 'react';

import styles from './Cell.module.scss';

const cx = classNames.bind(styles);

const Cell = ({ data: items }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const hasMulti = useMemo(() => {
    return items.length > 1;
  }, [items]);

  const toggle = () => {
    setCurrentIndex((currentIndex + 1) % items.length);
  };

  return (
    <div className={cx(['container', { clickable: hasMulti }])} onClick={toggle}>
      <div className={cx('label')}>{items[currentIndex].title}</div>
      <div className={cx('value')}>
        {items[currentIndex].value}
        <span className={cx('unit')}>{items[currentIndex].unit}</span>
      </div>
      {hasMulti && (
        <div className={cx('pagination')}>
          {Array.from({ length: items.length }, (_, index) => (
            <div key={index} className={cx(['dot', { active: index === currentIndex }])} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Cell;
